//#region src/locales/ja/stage.yaml
var data = {
	"chat": {
		"actions": { "retry": "再試行" },
		"message": { "character-name": {
			"core-system": "コアシステム",
			"you": "あなた"
		} },
		"reasoning": "推論",
		"sessions": {
			"title": "会話",
			"new": "+ New",
			"empty": "会話はまだありません",
			"cloud-badge": "クラウドに同期しました",
			"new-chat-fallback": "新しいチャット",
			"delete": "会話を削除"
		}
	},
	"render-error": {
		"title": "{renderer} でこのモデルを描画できませんでした",
		"description": "モデルは選択されていますが、ステージに表示できませんでした。",
		"report-description": "{renderer} で選択したモデルを描画できませんでした。\nモデル ID: {modelId}\nエラー: {error}"
	},
	"message": "何か話しかけてみましょう…",
	"send-mode": {
		"title": "キーを送信",
		"double-enter": "Enter二回"
	},
	"speech-output": {
		"mute": "音声をミュート",
		"unmute": "ミュートを解除"
	},
	"operations": {
		"load-models": "モデルの読み込み",
		"load-models-status": {
			"loading": "読み込み中",
			"ready": "準備完了"
		}
	},
	"select-a-audio-input": "音声入力デバイスを選択",
	"select-a-model": "モデルを選択",
	"select-a-voice": "声を選択",
	"viewers": { "debug-menu": {
		"emotions": "感情",
		"emotions-btn": {
			"angry": "😠 怒り",
			"awkward": "😳 戸惑い",
			"happy": "😄 喜び",
			"neutral": "🙂 ふつう",
			"question": "🤔 疑問",
			"sad": "😫 悲しい",
			"surprised": "🤯 驚き",
			"think": "🤨 思考中"
		},
		"vrm": {
			"camera": "カメラ",
			"model": { "title": "モデル" }
		}
	} },
	"profile-switcher": {
		"no-profile": "プロファイルがありません",
		"no-profiles": "まだプロファイルがありません",
		"save-as-new": "新規プロファイルとして保存",
		"new-profile-name": "プロファイル名",
		"manage": "プロファイルを管理"
	},
	"promo-banner": { "items": {
		"signin": {
			"watermark": "月",
			"fallbackLabel": "月の贈り物",
			"title": "7日間のログイン",
			"eventName": "スターダストやアバターフレーム、ローンチ特典を受け取るにはログインしてください。",
			"reward": "最大120スターダスト",
			"cta": "サインイン"
		},
		"build": {
			"watermark": "ビルド",
			"fallbackLabel": "ビルドボーナス",
			"title": "補給箱ボーナス",
			"eventName": "ビルド作業を完了してボーナスバウチャーを獲得し、資材を2倍にしよう。",
			"reward": "供給券5枚＋アップグレード用資材",
			"cta": "タスクを表示"
		},
		"spring": {
			"watermark": "春",
			"fallbackLabel": "春の抽選会",
			"title": "カプセルカーニバル",
			"eventName": "春の抽選会に参加して、バブルやチャーム、テーマ家具を解放しよう。",
			"reward": "初回半額＋レアチャーム付き",
			"cta": "今すぐ抽選"
		},
		"coupon": {
			"watermark": "トーク",
			"fallbackLabel": "クーポン",
			"title": "チャージクーポン",
			"eventName": "チャットでのやり取りを完了して、拡張パックやボイスパック用のクーポンを獲得しましょう。",
			"reward": "30のご利用で6お得 / 68のご利用で15お得",
			"cta": "クーポンを受け取る"
		},
		"home": {
			"watermark": "ホーム",
			"fallbackLabel": "部屋のテーマ",
			"title": "春のテーマアップデート",
			"eventName": "窓・机・ナイトランプのテーマをアンロックして、部屋を刷新しましょう。",
			"reward": "ログイン時の無料テーマ抽選チケット",
			"cta": "テーマを表示"
		}
	} },
	"waiting": "待機中",
	"websocket-status": {
		"connected": "接続済み",
		"disconnected": "未接続",
		"open-settings": "接続設定を開く"
	}
};
//#endregion
export { data as default };
